import { styled } from "@mui/material/styles";

import Button from "../Button";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));

export const StyledIconButton = styled(Button)(() => ({
  borderRadius: "0 8px 8px 0 !important",
  borderLeft: `1px solid #FFFFFF29 !important`,
  width: "40px !important",
  minWidth: "40px !important",
  padding: "0 !important",
  "& > span": {
    fontSize: "20px !important",
  },
}));

export const StyledButton = styled(Button, {
  shouldForwardProp: (props) => {
    return (props !== "hasOptions" && props !== "notClickable")
  },
})<{ hasOptions?: boolean, notClickable?: boolean }>(({ hasOptions, notClickable }) => ({
  borderRadius: hasOptions ? "8px 0 0 8px !important" : "8px",
  cursor: notClickable ? "default !important" : "pointer",
}));
